/*why-switch*/
/*using-ecosystem-standards*/
/*greater-control-of-source-code*/
/*less-configuration-for-your-repository-manager*/
/*migration-steps*/
/*step-1-update-gitignore*/
/*step-2-add-a-workspace-definition*/
/*step-3-add-a-packagejson-to-the-application*/
/*step-4-remove-nx-plugin*/
/*step-5-add-the-packagemanager-field*/
/*step-6-run-you-package-managers-install-command*/
/*step-7-install-turborepo*/
/*step-8-add-a-turbojson*/
/*step-9-run-turbo-build*/
/*step-10-enable-remote-caching-optional*/
/*advanced-migration-considerations*/
/*migrate-complex-monorepos-incrementally*/
/*installing-dependencies-where-theyre-used*/
/*creating-shared-packages*/
/*multi-language-monorepos*/
/*configuration-equivalents*/
/*global-configuration*/
/*task-configuration*/
/*cli-equivalents*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "从 Nx 迁移",
  "description": "学习如何从 Nx 迁移到 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "本指南将帮助你将现有的 Nx 存储库迁移到 Turborepo。"
  }, {
    "heading": "",
    "content": "¥This guide will help you migrate an existing Nx repository to Turborepo."
  }, {
    "heading": "",
    "content": "探索 从 Nx 启动器迁移到 Turborepo 的关键概念"
  }, {
    "heading": "",
    "content": "¥Explore key concepts by migrating from an Nx starter to Turborepo"
  }, {
    "heading": "",
    "content": "更复杂的迁移场景 注意事项"
  }, {
    "heading": "",
    "content": "¥Considerations for more complex migration scenarios"
  }, {
    "heading": "为什么要切换-why-switch",
    "content": "¥Why switch?"
  }, {
    "heading": "为什么要切换-why-switch",
    "content": "你选择从 Nx 迁移到 Turborepo 的原因有很多。下面，我们列出了开发者在迁移过程中参考的一些最常见动机。"
  }, {
    "heading": "为什么要切换-why-switch",
    "content": "¥There are many reasons why you may be choosing to migrate from Nx to Turborepo. Below, we've listed the most common motivations that developers have referenced for their migrations."
  }, {
    "heading": "使用生态系统标准-using-ecosystem-standards",
    "content": "¥Using ecosystem standards"
  }, {
    "heading": "使用生态系统标准-using-ecosystem-standards",
    "content": "Turborepo 的目标是轻量级，依靠你的代码库作为数据源。Turborepo 因其 JavaScript/TypeScript 支持而成为 基于 JavaScript 包管理器工作区构建 就是一个例子。"
  }, {
    "heading": "使用生态系统标准-using-ecosystem-standards",
    "content": "¥Turborepo's goal is to be lightweight, leaning on your repository as the source of truth. An example of this is Turborepo being built on top of JavaScript package manager workspaces for it's JavaScript/TypeScript support."
  }, {
    "heading": "使用生态系统标准-using-ecosystem-standards",
    "content": "相比之下，Nx 使用多层插件、依赖和其他 Nx 特定的代码来推断你的存储库信息。虽然这些插件可以提供一层功能并且是可选的，但希望迁移的 Nx 用户经常将从代码库中删除特定于 Nx 的代码作为他们进行迁移的主要动机。"
  }, {
    "heading": "使用生态系统标准-using-ecosystem-standards",
    "content": "¥By contrast, Nx uses layers of plugins, dependencies, and other Nx-specific code to infer information about your repository. While these plugins can provide a layer of functionality and are optional, Nx users looking to migrate often cite removing Nx-specific code from their codebase as a key motivation for their change."
  }, {
    "heading": "更好地控制源代码-greater-control-of-source-code",
    "content": "¥Greater control of source code"
  }, {
    "heading": "更好地控制源代码-greater-control-of-source-code",
    "content": "Nx 的理念在于用多层插件、依赖和 Nx 专用代码来封装你的代码。虽然这些代码层是可选的，但它们提供了 Nx 的大量价值，并且是 Nx 推荐的，因此大多数 Nx 仓库都包含它们。许多开发者在迁移到 Turborepo 时表示，这些层往往会创建一个混淆层，使其存储库脱离他们的控制，从而导致问题。"
  }, {
    "heading": "更好地控制源代码-greater-control-of-source-code",
    "content": "¥Nx’s philosophy involves wrapping your code with layers of plugins, dependencies, and Nx-specific code. While these layers of code are optional, they provide a great deal of Nx's value and are recommended by Nx, so most Nx repos have them. When migrating to Turborepo, many developers explain that these layers tend to create a layer of obfuscation that abstracts their repository away from their control, causing issues."
  }, {
    "heading": "更好地控制源代码-greater-control-of-source-code",
    "content": "Turborepo 选择让你根据自己的意愿处理工具，你可以根据需要配置（或不配置）任何工具。"
  }, {
    "heading": "更好地控制源代码-greater-control-of-source-code",
    "content": "¥Turborepo chooses to let you handle your tooling on your own terms, configuring (or not configuring) any of your tooling as you please."
  }, {
    "heading": "减少存储库管理器的配置-less-configuration-for-your-repository-manager",
    "content": "¥Less configuration for your repository manager"
  }, {
    "heading": "减少存储库管理器的配置-less-configuration-for-your-repository-manager",
    "content": "迁移到 Turborepo 可能需要删除你之前为 Nx 使用的配置，并用更少的 Turborepo 配置替换，因为 Turborepo 会自动推断你的代码库需求。例如，以下是 Turborepo 和 Nx 以下使用 的等效启动器中提供的工具特定配置。"
  }, {
    "heading": "减少存储库管理器的配置-less-configuration-for-your-repository-manager",
    "content": "¥Migrating to Turborepo will likely require deleting previous configuration that you had for Nx and replacing it with less configuration for Turborepo, since Turborepo will automatically infer your repository's needs. For example, here are the tool-specific configurations you'll find in the equivalent starters for Turborepo and Nx used below."
  }, {
    "heading": "迁移步骤-migration-steps",
    "content": "¥Migration steps"
  }, {
    "heading": "迁移步骤-migration-steps",
    "content": "我们此次迁移的目标是尽快获得一个可以运行的 Turborepo 任务，以便你可以逐步采用 Turborepo 的功能。我们将首先使用 Nx 脚手架创建一个包含 Next.js 应用的仓库。"
  }, {
    "heading": "迁移步骤-migration-steps",
    "content": "¥Our goal for this migration is to get a working Turborepo task as quickly as possible, so that you can adopt Turborepo features incrementally. We’ll start by using the Nx scaffolder to create a repository with a Next.js app."
  }, {
    "heading": "步骤-1更新-gitignore-step-1-update-gitignore",
    "content": "¥Step 1: Update .gitignore"
  }, {
    "heading": "步骤-1更新-gitignore-step-1-update-gitignore",
    "content": "Turborepo 使用 .turbo 目录来保存本地缓存和有关你的仓库的其他信息。因此，应该将其添加到你的 .gitignore 中。"
  }, {
    "heading": "步骤-1更新-gitignore-step-1-update-gitignore",
    "content": "¥Turborepo uses the .turbo directory to hold local caches and other information about your repository. For this reason, it should be added to your .gitignore."
  }, {
    "heading": "步骤-2添加工作区定义-step-2-add-a-workspace-definition",
    "content": "¥Step 2: Add a workspace definition"
  }, {
    "heading": "步骤-2添加工作区定义-step-2-add-a-workspace-definition",
    "content": "Turborepo 构建于 JavaScript 生态系统标准包管理器工作区之上。将目录路径添加到将包含包的工作区中。"
  }, {
    "heading": "步骤-2添加工作区定义-step-2-add-a-workspace-definition",
    "content": "¥Turborepo is built on top of package manager workspaces, a JavaScript ecosystem standard. Add the directory paths to the workspace that will contain packages."
  }, {
    "heading": "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
    "content": "¥Step 3: Add a package.json to the application"
  }, {
    "heading": "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
    "content": "Turborepo 使用标准的 package.json 文件，而不是像 project.json 那样添加额外的配置文件。"
  }, {
    "heading": "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
    "content": "¥Rather than adding additional configuration files like project.json, Turborepo uses the standard package.json file."
  }, {
    "heading": "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
    "content": "将 package.json 添加到 starter 应用。在 ./apps/starter/package.json 中创建一个包含 dev 和 build 脚本的 package.json。"
  }, {
    "heading": "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
    "content": "¥Add a package.json to the starter application. Create a package.json at ./apps/starter/package.json that contains a dev and build script."
  }, {
    "heading": "步骤-4删除-nx-插件-step-4-remove-nx-plugin",
    "content": "¥Step 4: Remove Nx plugin"
  }, {
    "heading": "步骤-4删除-nx-插件-step-4-remove-nx-plugin",
    "content": "从 ./apps/starter/next.config.js 中删除 Nx 插件。下面的示例文件没有配置，但你现有的 Next.js 应用可能需要一些配置。"
  }, {
    "heading": "步骤-4删除-nx-插件-step-4-remove-nx-plugin",
    "content": "¥Remove the Nx plugin from ./apps/starter/next.config.js. The example file below doesn’t have configuration, though your existing Next.js application may need some."
  }, {
    "heading": "步骤-5添加-packagemanager-字段-step-5-add-the-packagemanager-field",
    "content": "¥Step 5: Add the packageManager field"
  }, {
    "heading": "步骤-5添加-packagemanager-字段-step-5-add-the-packagemanager-field",
    "content": "根 package.json 需要包含 packageManager 字段。这确保了存储库中的开发者使用正确的包管理器，并且 Turborepo 可以根据你的锁定文件优化你的包图。"
  }, {
    "heading": "步骤-5添加-packagemanager-字段-step-5-add-the-packagemanager-field",
    "content": "¥The root package.json needs to have the packageManager field. This ensures developers in the repository use the correct package manager, and that Turborepo can optimize your package graph based on your lockfile."
  }, {
    "heading": "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
    "content": "¥Step 6: Run you package manager's install command"
  }, {
    "heading": "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
    "content": "通过运行安装命令来更新锁定文件。"
  }, {
    "heading": "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
    "content": "¥Update your lockfile by running your installation command."
  }, {
    "heading": "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
    "content": "完成此操作后，你应该会看到一个 lockfile diff，表明该包已添加到包管理器的工作区中。"
  }, {
    "heading": "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
    "content": "¥Once you've done this, you should see a lockfile diff, indicating that the package has been added to the package manager's workspace."
  }, {
    "heading": "步骤-7安装-turborepo-step-7-install-turborepo",
    "content": "¥Step 7: Install Turborepo"
  }, {
    "heading": "步骤-7安装-turborepo-step-7-install-turborepo",
    "content": "将 Turborepo 添加到工作区的根 package.json。"
  }, {
    "heading": "步骤-7安装-turborepo-step-7-install-turborepo",
    "content": "¥Add Turborepo to the root package.json of the workspace."
  }, {
    "heading": "步骤-7安装-turborepo-step-7-install-turborepo",
    "content": "你还可以选择全局安装 turbo，以便在使用 Turborepo 时更加方便。"
  }, {
    "heading": "步骤-7安装-turborepo-step-7-install-turborepo",
    "content": "¥You can also optionally install turbo globally for added convenience when working with Turborepo."
  }, {
    "heading": "步骤-8添加-turbojson-step-8-add-a-turbojson",
    "content": "¥Step 8: Add a turbo.json"
  }, {
    "heading": "步骤-8添加-turbojson-step-8-add-a-turbojson",
    "content": "在根目录下创建一个 turbo.json 来注册你的任务并描述它们之间的任务依赖。"
  }, {
    "heading": "步骤-8添加-turbojson-step-8-add-a-turbojson",
    "content": "¥Create a turbo.json at the root to register your tasks and describe their task dependencies."
  }, {
    "heading": "步骤-9运行-turbo-build-step-9-run-turbo-build",
    "content": "¥Step 9: Run turbo build"
  }, {
    "heading": "步骤-9运行-turbo-build-step-9-run-turbo-build",
    "content": "使用 Turborepo 构建应用。使用全局 turbo，这将是 turbo build。你也可以通过包管理器运行以下命令："
  }, {
    "heading": "步骤-9运行-turbo-build-step-9-run-turbo-build",
    "content": "¥Build the application with Turborepo. Using global turbo, this would be turbo build. You can also run the command through your package manager:"
  }, {
    "heading": "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
    "content": "¥Step 10: Enable Remote Caching (optional)"
  }, {
    "heading": "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
    "content": "默认情况下，Turborepo 会在你运行时连接到免费的 Vercel 远程缓存："
  }, {
    "heading": "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
    "content": "¥By default, Turborepo will connect to the free-to-use Vercel Remote Cache when you run:"
  }, {
    "heading": "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
    "content": "你还可以配置自托管远程缓存。"
  }, {
    "heading": "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
    "content": "¥You may also configure a self-hosted Remote Cache."
  }, {
    "heading": "高级迁移注意事项-advanced-migration-considerations",
    "content": "¥Advanced migration considerations"
  }, {
    "heading": "高级迁移注意事项-advanced-migration-considerations",
    "content": "虽然上面的迁移指南是一个很好的起点，但单一仓库的可能性和功能范围之广意味着很难为所有情况创建通用的说明。下面，我们列出了一些你可能正在考虑的常见后续步骤。"
  }, {
    "heading": "高级迁移注意事项-advanced-migration-considerations",
    "content": "¥While the migration guide above is a good starting point, the breadth of possibilities and capabilities of monorepos means that its difficult to create generalized instructions for all cases. Below, we’ve listed some common next steps that you may be thinking about."
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "¥Migrate complex monorepos incrementally"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "我们鼓励增量迁移，这意味着你的代码库中将同时包含 Nx 和 Turborepo。确保花时间了解 Nx 任务图的构建方式。拆分任务图可能包括以下策略："
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "¥We encourage incremental migration, meaning you will have both of Nx and Turborepo in your repository at the same time. Make sure to spend time understanding how your Nx task graph is constructed. Splitting up the task graph may include strategies like:"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "一次迁移一个任务：将 nx run lint 更改为 turbo run lint"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "¥Migrating one task at a time: Changing nx run lint to turbo run lint"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "一次迁移一个包/项目：将 nx run-many lint test --projects=web 更改为 turbo run lint test --filter=web"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "¥Migrating one package/project at a time: Changing nx run-many lint test --projects=web to turbo run lint test --filter=web"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "重复运行某些任务：为了确保稳定性，你可以选择在迁移的早期阶段仍在熟悉和建立确定性时运行 turbo run lint 和 nx run lint。"
  }, {
    "heading": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "¥Double-running some of your tasks: To ensure stability, you may choose to run turbo run lint and nx run lint while you're still getting comfortable and building certainty in the early phases of your migration."
  }, {
    "heading": "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
    "content": "¥Installing dependencies where they're used"
  }, {
    "heading": "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
    "content": "Turborepo 建议使用 在使用它们的地方安装包 来提高缓存命中率，增强依赖修剪能力，并向开发者明确哪些依赖对应哪些包。这与 Nx 策略不同，Nx 策略将所有依赖安装在仓库的根目录下，从而使所有依赖都可供工作区中的所有包使用。"
  }, {
    "heading": "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
    "content": "¥Turborepo recommends installing packages where they're used to improve cache hit ratios, help dependency pruning capability, and clarify for developers which dependencies are meant for which packages. This is different from the Nx strategy, where all dependencies are installed at the root of the repository, making all dependencies available to all packages in the workspace."
  }, {
    "heading": "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
    "content": "过去，Nx 建议将所有依赖安装在仓库的根目录中，从而使所有依赖都可供工作区中的所有包使用。如果你遵循此指南，我们强烈建议你将需要依赖的包和应用移至 package.json。访问我们关于管理依赖的文档 了解更多。"
  }, {
    "heading": "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
    "content": "¥Historically, Nx has recommended installing all dependencies in the root of the repository, making all dependencies available to all packages in the Workspace. If you followed this guidance, we highly recommend that you move dependencies to the package.json's for packages and applications that need them. Visit our documentation on managing dependencies to learn more."
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "¥Creating shared packages"
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "你将按照与上述大致相同的步骤将包添加到包管理器的工作区。"
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "¥You’ll follow roughly the same set of steps as above to add a package to your package manager’s workspace."
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "确保软件包的目录包含在工作区定义中（例如 ./packages/* ）。"
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "¥Ensure the package’s directory is included in the workspace definition (like ./packages/* )."
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "将 package.json 添加到包含其运行所需脚本的包中。"
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "¥Add a package.json to the package with the scripts it needs to run."
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "检查 turbo.json 中的任务依赖，以确保你的依赖图符合你的要求。"
  }, {
    "heading": "创建共享包-creating-shared-packages",
    "content": "¥Check task dependencies in turbo.json to make sure your dependency graph meets your requirements."
  }, {
    "heading": "多语言单一仓库-multi-language-monorepos",
    "content": "¥Multi-language monorepos"
  }, {
    "heading": "多语言单一仓库-multi-language-monorepos",
    "content": "Turborepo 原生支持 JavaScript 和 TypeScript，并支持你想要使用的任何其他语言。访问多语言支持文档 了解更多。"
  }, {
    "heading": "多语言单一仓库-multi-language-monorepos",
    "content": "¥Turborepo natively supports JavaScript and TypeScript, with secondary support for any other languages you’d like to use. Visit the Multi-Language support documentation to learn more."
  }, {
    "heading": "配置等效项-configuration-equivalents",
    "content": "¥Configuration equivalents"
  }, {
    "heading": "配置等效项-configuration-equivalents",
    "content": "可以使用下表将 nx.json 中的配置映射到 turbo.json。"
  }, {
    "heading": "配置等效项-configuration-equivalents",
    "content": "¥Configuration found in nx.json can be mapped to turbo.json using the tables below."
  }, {
    "heading": "配置等效项-configuration-equivalents",
    "content": "Nx 和 Turborepo 中用于捕获文件的 glob 大部分是相同的。有关详细信息和特殊情况，请参阅 我们的文件全局规范。"
  }, {
    "heading": "配置等效项-configuration-equivalents",
    "content": "¥The majorify of globs for capturing files are the same between Nx and\nTurborepo. See our file glob specification for\ndetails and edge cases."
  }, {
    "heading": "全局配置-global-configuration",
    "content": "¥Global configuration"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "Nx"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "Turborepo"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "sharedGlobals"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "globalDependencies"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "sharedGlobals.env"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "globalEnv"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "sharedGlobals.namedInput"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "globalDependencies"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "cacheDirectory"
  }, {
    "heading": "全局配置-global-configuration",
    "content": "cacheDir"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "¥Task configuration"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "Nx"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "Turborepo"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "inputs 文件"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "tasks[task].inputs"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "inputs.env"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "tasks[task].env"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "outputs 文件"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "tasks[task].outputs"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "cache"
  }, {
    "heading": "任务配置-task-configuration",
    "content": "tasks[task].cache"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "¥CLI equivalents"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "Nx"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "Turborepo"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "nx generate"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "turbo generate"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "nx run"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "turbo run"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "nx run-many"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "turbo run"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "nx reset"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--force"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--parallel"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--concurrency"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--nxBail"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--continue"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--projects"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--filter"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--graph"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--graph"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--output-style"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--log-order"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--no-cloud"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--cache"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--verbose"
  }, {
    "heading": "cli-等效项-cli-equivalents",
    "content": "--verbosity"
  }],
  "headings": [{
    "id": "为什么要切换-why-switch",
    "content": "为什么要切换？ /*why-switch*/"
  }, {
    "id": "使用生态系统标准-using-ecosystem-standards",
    "content": "使用生态系统标准 /*using-ecosystem-standards*/"
  }, {
    "id": "更好地控制源代码-greater-control-of-source-code",
    "content": "更好地控制源代码 /*greater-control-of-source-code*/"
  }, {
    "id": "减少存储库管理器的配置-less-configuration-for-your-repository-manager",
    "content": "减少存储库管理器的配置 /*less-configuration-for-your-repository-manager*/"
  }, {
    "id": "迁移步骤-migration-steps",
    "content": "迁移步骤 /*migration-steps*/"
  }, {
    "id": "步骤-1更新-gitignore-step-1-update-gitignore",
    "content": "步骤 1：更新 .gitignore /*step-1-update-gitignore*/"
  }, {
    "id": "步骤-2添加工作区定义-step-2-add-a-workspace-definition",
    "content": "步骤 2：添加工作区定义 /*step-2-add-a-workspace-definition*/"
  }, {
    "id": "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
    "content": "步骤 3：将 package.json 文件添加到应用 /*step-3-add-a-packagejson-to-the-application*/"
  }, {
    "id": "步骤-4删除-nx-插件-step-4-remove-nx-plugin",
    "content": "步骤 4：删除 Nx 插件 /*step-4-remove-nx-plugin*/"
  }, {
    "id": "步骤-5添加-packagemanager-字段-step-5-add-the-packagemanager-field",
    "content": "步骤 5：添加 packageManager 字段 /*step-5-add-the-packagemanager-field*/"
  }, {
    "id": "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
    "content": "步骤 6：运行包管理器的安装命令 /*step-6-run-you-package-managers-install-command*/"
  }, {
    "id": "步骤-7安装-turborepo-step-7-install-turborepo",
    "content": "步骤 7：安装 Turborepo /*step-7-install-turborepo*/"
  }, {
    "id": "步骤-8添加-turbojson-step-8-add-a-turbojson",
    "content": "步骤 8：添加 turbo.json /*step-8-add-a-turbojson*/"
  }, {
    "id": "步骤-9运行-turbo-build-step-9-run-turbo-build",
    "content": "步骤 9：运行 turbo build /*step-9-run-turbo-build*/"
  }, {
    "id": "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
    "content": "步骤 10：启用远程缓存（可选） /*step-10-enable-remote-caching-optional*/"
  }, {
    "id": "高级迁移注意事项-advanced-migration-considerations",
    "content": "高级迁移注意事项 /*advanced-migration-considerations*/"
  }, {
    "id": "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
    "content": "逐步迁移复杂的单一存储库 /*migrate-complex-monorepos-incrementally*/"
  }, {
    "id": "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
    "content": "在使用依赖的位置安装它们 /*installing-dependencies-where-theyre-used*/"
  }, {
    "id": "创建共享包-creating-shared-packages",
    "content": "创建共享包 /*creating-shared-packages*/"
  }, {
    "id": "多语言单一仓库-multi-language-monorepos",
    "content": "多语言单一仓库 /*multi-language-monorepos*/"
  }, {
    "id": "配置等效项-configuration-equivalents",
    "content": "配置等效项 /*configuration-equivalents*/"
  }, {
    "id": "全局配置-global-configuration",
    "content": "全局配置 /*global-configuration*/"
  }, {
    "id": "任务配置-task-configuration",
    "content": "任务配置 /*task-configuration*/"
  }, {
    "id": "cli-等效项-cli-equivalents",
    "content": "CLI 等效项 /*cli-equivalents*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#为什么要切换-why-switch",
  title: _jsx(_Fragment, {
    children: "为什么要切换？ "
  })
}, {
  depth: 3,
  url: "#使用生态系统标准-using-ecosystem-standards",
  title: _jsx(_Fragment, {
    children: "使用生态系统标准 "
  })
}, {
  depth: 3,
  url: "#更好地控制源代码-greater-control-of-source-code",
  title: _jsx(_Fragment, {
    children: "更好地控制源代码 "
  })
}, {
  depth: 3,
  url: "#减少存储库管理器的配置-less-configuration-for-your-repository-manager",
  title: _jsx(_Fragment, {
    children: "减少存储库管理器的配置 "
  })
}, {
  depth: 2,
  url: "#迁移步骤-migration-steps",
  title: _jsx(_Fragment, {
    children: "迁移步骤 "
  })
}, {
  depth: 3,
  url: "#步骤-1更新-gitignore-step-1-update-gitignore",
  title: _jsx(_Fragment, {
    children: "步骤 1：更新 .gitignore "
  })
}, {
  depth: 3,
  url: "#步骤-2添加工作区定义-step-2-add-a-workspace-definition",
  title: _jsx(_Fragment, {
    children: "步骤 2：添加工作区定义 "
  })
}, {
  depth: 3,
  url: "#步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
  title: _jsx(_Fragment, {
    children: "步骤 3：将 package.json 文件添加到应用 "
  })
}, {
  depth: 3,
  url: "#步骤-4删除-nx-插件-step-4-remove-nx-plugin",
  title: _jsx(_Fragment, {
    children: "步骤 4：删除 Nx 插件 "
  })
}, {
  depth: 3,
  url: "#步骤-5添加-packagemanager-字段-step-5-add-the-packagemanager-field",
  title: _jsxs(_Fragment, {
    children: ["步骤 5：添加 ", _jsx("code", {
      children: "packageManager"
    }), " 字段 "]
  })
}, {
  depth: 3,
  url: "#步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
  title: _jsx(_Fragment, {
    children: "步骤 6：运行包管理器的安装命令 "
  })
}, {
  depth: 3,
  url: "#步骤-7安装-turborepo-step-7-install-turborepo",
  title: _jsx(_Fragment, {
    children: "步骤 7：安装 Turborepo "
  })
}, {
  depth: 3,
  url: "#步骤-8添加-turbojson-step-8-add-a-turbojson",
  title: _jsxs(_Fragment, {
    children: ["步骤 8：添加 ", _jsx("code", {
      children: "turbo.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#步骤-9运行-turbo-build-step-9-run-turbo-build",
  title: _jsxs(_Fragment, {
    children: ["步骤 9：运行 ", _jsx("code", {
      children: "turbo build"
    }), " "]
  })
}, {
  depth: 3,
  url: "#步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
  title: _jsx(_Fragment, {
    children: "步骤 10：启用远程缓存（可选） "
  })
}, {
  depth: 2,
  url: "#高级迁移注意事项-advanced-migration-considerations",
  title: _jsx(_Fragment, {
    children: "高级迁移注意事项 "
  })
}, {
  depth: 3,
  url: "#逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
  title: _jsx(_Fragment, {
    children: "逐步迁移复杂的单一存储库 "
  })
}, {
  depth: 3,
  url: "#在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
  title: _jsx(_Fragment, {
    children: "在使用依赖的位置安装它们 "
  })
}, {
  depth: 3,
  url: "#创建共享包-creating-shared-packages",
  title: _jsx(_Fragment, {
    children: "创建共享包 "
  })
}, {
  depth: 3,
  url: "#多语言单一仓库-multi-language-monorepos",
  title: _jsx(_Fragment, {
    children: "多语言单一仓库 "
  })
}, {
  depth: 2,
  url: "#配置等效项-configuration-equivalents",
  title: _jsx(_Fragment, {
    children: "配置等效项 "
  })
}, {
  depth: 3,
  url: "#全局配置-global-configuration",
  title: _jsx(_Fragment, {
    children: "全局配置 "
  })
}, {
  depth: 3,
  url: "#任务配置-task-configuration",
  title: _jsx(_Fragment, {
    children: "任务配置 "
  })
}, {
  depth: 3,
  url: "#cli-等效项-cli-equivalents",
  title: _jsx(_Fragment, {
    children: "CLI 等效项 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  }, {Callout} = _components;
  if (!Callout) _missingMdxReference("Callout", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "本指南将帮助你将现有的 Nx 存储库迁移到 Turborepo。"
    }), "\n", _jsx(_components.p, {
      children: "¥This guide will help you migrate an existing Nx repository to Turborepo."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["探索 ", _jsx(_components.a, {
            href: "#migration-steps",
            children: "从 Nx 启动器迁移到 Turborepo"
          }), " 的关键概念"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Explore key concepts by ", _jsx(_components.a, {
            href: "#migration-steps",
            children: "migrating from an Nx starter to Turborepo"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "#advanced-migration-considerations",
            children: "更复杂的迁移场景"
          }), " 注意事项"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Considerations for ", _jsx(_components.a, {
            href: "#advanced-migration-considerations",
            children: "more complex migration scenarios"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "为什么要切换-why-switch",
      children: "为什么要切换？ "
    }), "\n", _jsx(_components.p, {
      children: "¥Why switch?"
    }), "\n", _jsx(_components.p, {
      children: "你选择从 Nx 迁移到 Turborepo 的原因有很多。下面，我们列出了开发者在迁移过程中参考的一些最常见动机。"
    }), "\n", _jsx(_components.p, {
      children: "¥There are many reasons why you may be choosing to migrate from Nx to Turborepo. Below, we've listed the most common motivations that developers have referenced for their migrations."
    }), "\n", _jsx(_components.h3, {
      id: "使用生态系统标准-using-ecosystem-standards",
      children: "使用生态系统标准 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using ecosystem standards"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 的目标是轻量级，依靠你的代码库作为数据源。Turborepo 因其 JavaScript/TypeScript 支持而成为 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository",
        children: "基于 JavaScript 包管理器工作区构建"
      }), " 就是一个例子。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo's goal is to be lightweight, leaning on your repository as the source of truth. An example of this is Turborepo being ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository",
        children: "built on top of JavaScript package manager workspaces"
      }), " for it's JavaScript/TypeScript support."]
    }), "\n", _jsx(_components.p, {
      children: "相比之下，Nx 使用多层插件、依赖和其他 Nx 特定的代码来推断你的存储库信息。虽然这些插件可以提供一层功能并且是可选的，但希望迁移的 Nx 用户经常将从代码库中删除特定于 Nx 的代码作为他们进行迁移的主要动机。"
    }), "\n", _jsx(_components.p, {
      children: "¥By contrast, Nx uses layers of plugins, dependencies, and other Nx-specific code to infer information about your repository. While these plugins can provide a layer of functionality and are optional, Nx users looking to migrate often cite removing Nx-specific code from their codebase as a key motivation for their change."
    }), "\n", _jsx(_components.h3, {
      id: "更好地控制源代码-greater-control-of-source-code",
      children: "更好地控制源代码 "
    }), "\n", _jsx(_components.p, {
      children: "¥Greater control of source code"
    }), "\n", _jsx(_components.p, {
      children: "Nx 的理念在于用多层插件、依赖和 Nx 专用代码来封装你的代码。虽然这些代码层是可选的，但它们提供了 Nx 的大量价值，并且是 Nx 推荐的，因此大多数 Nx 仓库都包含它们。许多开发者在迁移到 Turborepo 时表示，这些层往往会创建一个混淆层，使其存储库脱离他们的控制，从而导致问题。"
    }), "\n", _jsx(_components.p, {
      children: "¥Nx’s philosophy involves wrapping your code with layers of plugins, dependencies, and Nx-specific code. While these layers of code are optional, they provide a great deal of Nx's value and are recommended by Nx, so most Nx repos have them. When migrating to Turborepo, many developers explain that these layers tend to create a layer of obfuscation that abstracts their repository away from their control, causing issues."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 选择让你根据自己的意愿处理工具，你可以根据需要配置（或不配置）任何工具。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo chooses to let you handle your tooling on your own terms, configuring (or not configuring) any of your tooling as you please."
    }), "\n", _jsx(_components.h3, {
      id: "减少存储库管理器的配置-less-configuration-for-your-repository-manager",
      children: "减少存储库管理器的配置 "
    }), "\n", _jsx(_components.p, {
      children: "¥Less configuration for your repository manager"
    }), "\n", _jsxs(_components.p, {
      children: ["迁移到 Turborepo 可能需要删除你之前为 Nx 使用的配置，并用更少的 Turborepo 配置替换，因为 Turborepo 会自动推断你的代码库需求。例如，以下是 Turborepo 和 Nx ", _jsx(_components.a, {
        href: "#migration-steps",
        children: "以下使用"
      }), " 的等效启动器中提供的工具特定配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Migrating to Turborepo will likely require deleting previous configuration that you had for Nx and replacing it with less configuration for Turborepo, since Turborepo will automatically infer your repository's needs. For example, here are the tool-specific configurations you'll find in the equivalent starters for Turborepo and Nx ", _jsx(_components.a, {
        href: "#migration-steps",
        children: "used below"
      }), "."]
    }), "\n", _jsxs(Tabs, {
      items: ["Turborepo", "Nx"],
      children: [_jsx(Tab, {
        value: "Turborepo",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"$schema\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"/schema.json\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"tui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \".env*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"check-types\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^check-types\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"cache\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " false"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"persistent\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsxs(Tab, {
        value: "Nx",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "nx.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"$schema\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"./node_modules/nx/schemas/nx-schema.json\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"namedInputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"default\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"{projectRoot}/**/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"sharedGlobals\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"production\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"default\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/.eslintrc.json\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/eslint.config.cjs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/**/?(*.)+(spec|test).[jt]s?(x)?(.snap)\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/tsconfig.spec.json\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/jest.config.[jt]s\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/src/test-setup.[jt]s\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      \"!{projectRoot}/test-setup.[jt]s\""
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    ]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"sharedGlobals\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"{workspaceRoot}/.github/workflows/ci.yml\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"nxCloudId\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"6789ec521d90a2165398f39a\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"plugins\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    {"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@nx/next/plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"options\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"startTargetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"start\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"buildTargetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"devTargetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"serveStaticTargetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"serve-static\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      }"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    {"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@nx/playwright/plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"options\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"targetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"e2e\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      }"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    {"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@nx/eslint/plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"options\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"targetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"lint\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      }"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    {"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@nx/jest/plugin\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"options\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"targetName\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"test\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  ]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"targetDefaults\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"e2e-ci--**/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"generators\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@nx/next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"application\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"style\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"tailwind\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "        \"linter\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "project.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"name\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"starter\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"$schema\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"../../node_modules/nx/schemas/project-schema.json\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"sourceRoot\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"apps/starter\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"projectType\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"application\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tags\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " []"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"// targets\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"to see all targets run: nx show project starter --web\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"targets\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {}"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "迁移步骤-migration-steps",
      children: "迁移步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Migration steps"
    }), "\n", _jsx(_components.p, {
      children: "我们此次迁移的目标是尽快获得一个可以运行的 Turborepo 任务，以便你可以逐步采用 Turborepo 的功能。我们将首先使用 Nx 脚手架创建一个包含 Next.js 应用的仓库。"
    }), "\n", _jsx(_components.p, {
      children: "¥Our goal for this migration is to get a working Turborepo task as quickly as possible, so that you can adopt Turborepo features incrementally. We’ll start by using the Nx scaffolder to create a repository with a Next.js app."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-nx-workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --preset=next"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --ci=skip"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --e2eTestRunner=none"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --style=tailwind"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --nextAppDir=true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --nextSrcDir=false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --packageManager=pnpm"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --appName=starter"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "步骤-1更新-gitignore-step-1-update-gitignore",
      children: "步骤 1：更新 .gitignore "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 1: Update .gitignore"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 使用 .turbo 目录来保存本地缓存和有关你的仓库的其他信息。因此，应该将其添加到你的 ", _jsx(_components.code, {
        children: ".gitignore"
      }), " 中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo uses the .turbo directory to hold local caches and other information about your repository. For this reason, it should be added to your ", _jsx(_components.code, {
        children: ".gitignore"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".gitignore",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: ".turbo"
            })
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "步骤-2添加工作区定义-step-2-add-a-workspace-definition",
      children: "步骤 2：添加工作区定义 "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 2: Add a workspace definition"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 构建于 JavaScript 生态系统标准包管理器工作区之上。将目录路径添加到将包含包的工作区中。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo is built on top of package manager workspaces, a JavaScript ecosystem standard. Add the directory paths to the workspace that will contain packages."
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "pnpm-workspace.yaml",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "packages"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  - "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "apps/*"
                })]
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "步骤-3将-packagejson-文件添加到应用-step-3-add-a-packagejson-to-the-application",
      children: "步骤 3：将 package.json 文件添加到应用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 3: Add a package.json to the application"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 使用标准的 ", _jsx(_components.code, {
        children: "package.json"
      }), " 文件，而不是像 ", _jsx(_components.code, {
        children: "project.json"
      }), " 那样添加额外的配置文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Rather than adding additional configuration files like ", _jsx(_components.code, {
        children: "project.json"
      }), ", Turborepo uses the standard ", _jsx(_components.code, {
        children: "package.json"
      }), " file."]
    }), "\n", _jsxs(_components.p, {
      children: ["将 ", _jsx(_components.code, {
        children: "package.json"
      }), " 添加到 ", _jsx(_components.code, {
        children: "starter"
      }), " 应用。在 ", _jsx(_components.code, {
        children: "./apps/starter/package.json"
      }), " 中创建一个包含 ", _jsx(_components.code, {
        children: "dev"
      }), " 和 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本的 ", _jsx(_components.code, {
        children: "package.json"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Add a ", _jsx(_components.code, {
        children: "package.json"
      }), " to the ", _jsx(_components.code, {
        children: "starter"
      }), " application. Create a ", _jsx(_components.code, {
        children: "package.json"
      }), " at ", _jsx(_components.code, {
        children: "./apps/starter/package.json"
      }), " that contains a ", _jsx(_components.code, {
        children: "dev"
      }), " and ", _jsx(_components.code, {
        children: "build"
      }), " script."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/starter/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"starter\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"next dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"next build\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "步骤-4删除-nx-插件-step-4-remove-nx-plugin",
      children: "步骤 4：删除 Nx 插件 "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 4: Remove Nx plugin"
    }), "\n", _jsx(_components.p, {
      children: "从 ./apps/starter/next.config.js 中删除 Nx 插件。下面的示例文件没有配置，但你现有的 Next.js 应用可能需要一些配置。"
    }), "\n", _jsx(_components.p, {
      children: "¥Remove the Nx plugin from ./apps/starter/next.config.js. The example file below doesn’t have configuration, though your existing Next.js application may need some."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/starter/next.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/** "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "@type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " {import('next').NextConfig}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " */"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " nextConfig"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {};"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "module"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "exports"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " nextConfig;"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "步骤-5添加-packagemanager-字段-step-5-add-the-packagemanager-field",
      children: ["步骤 5：添加 ", _jsx(_components.code, {
        children: "packageManager"
      }), " 字段 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Step 5: Add the ", _jsx(_components.code, {
        children: "packageManager"
      }), " field"]
    }), "\n", _jsxs(_components.p, {
      children: ["根 package.json 需要包含 ", _jsx(_components.code, {
        children: "packageManager"
      }), " 字段。这确保了存储库中的开发者使用正确的包管理器，并且 Turborepo 可以根据你的锁定文件优化你的包图。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The root package.json needs to have the ", _jsx(_components.code, {
        children: "packageManager"
      }), " field. This ensures developers in the repository use the correct package manager, and that Turborepo can optimize your package graph based on your lockfile."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"pnpm@9.0.0\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"yarn@1.22.19\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"npm@10.0.0\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"bun@1.2.0\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "步骤-6运行包管理器的安装命令-step-6-run-you-package-managers-install-command",
      children: "步骤 6：运行包管理器的安装命令 "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 6: Run you package manager's install command"
    }), "\n", _jsx(_components.p, {
      children: "通过运行安装命令来更新锁定文件。"
    }), "\n", _jsx(_components.p, {
      children: "¥Update your lockfile by running your installation command."
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "完成此操作后，你应该会看到一个 lockfile diff，表明该包已添加到包管理器的工作区中。"
    }), "\n", _jsx(_components.p, {
      children: "¥Once you've done this, you should see a lockfile diff, indicating that the package has been added to the package manager's workspace."
    }), "\n", _jsx(_components.h3, {
      id: "步骤-7安装-turborepo-step-7-install-turborepo",
      children: "步骤 7：安装 Turborepo "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 7: Install Turborepo"
    }), "\n", _jsxs(_components.p, {
      children: ["将 Turborepo 添加到工作区的根 ", _jsx(_components.code, {
        children: "package.json"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Add Turborepo to the root ", _jsx(_components.code, {
        children: "package.json"
      }), " of the workspace."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspace-root"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --ignore-workspace-root-check"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["你还可以选择全局安装 ", _jsx(_components.code, {
        children: "turbo"
      }), "，以便在使用 Turborepo 时更加方便。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can also optionally install ", _jsx(_components.code, {
        children: "turbo"
      }), " globally for added convenience when working with Turborepo."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " global"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "步骤-8添加-turbojson-step-8-add-a-turbojson",
      children: ["步骤 8：添加 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Step 8: Add a ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["在根目录下创建一个 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 来注册你的任务并描述它们之间的任务依赖。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Create a ", _jsx(_components.code, {
        children: "turbo.json"
      }), " at the root to register your tasks and describe their task dependencies."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "步骤-9运行-turbo-build-step-9-run-turbo-build",
      children: ["步骤 9：运行 ", _jsx(_components.code, {
        children: "turbo build"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Step 9: Run ", _jsx(_components.code, {
        children: "turbo build"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["使用 Turborepo 构建应用。使用全局 ", _jsx(_components.code, {
        children: "turbo"
      }), "，这将是 ", _jsx(_components.code, {
        children: "turbo build"
      }), "。你也可以通过包管理器运行以下命令："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Build the application with Turborepo. Using global ", _jsx(_components.code, {
        children: "turbo"
      }), ", this would be ", _jsx(_components.code, {
        children: "turbo build"
      }), ". You can also run the command through your package manager:"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " exec"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " run"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " run"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " build"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "步骤-10启用远程缓存可选-step-10-enable-remote-caching-optional",
      children: "步骤 10：启用远程缓存（可选） "
    }), "\n", _jsx(_components.p, {
      children: "¥Step 10: Enable Remote Caching (optional)"
    }), "\n", _jsx(_components.p, {
      children: "默认情况下，Turborepo 会在你运行时连接到免费的 Vercel 远程缓存："
    }), "\n", _jsx(_components.p, {
      children: "¥By default, Turborepo will connect to the free-to-use Vercel Remote Cache when you run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "你还可以配置自托管远程缓存。"
    }), "\n", _jsx(_components.p, {
      children: "¥You may also configure a self-hosted Remote Cache."
    }), "\n", _jsx(_components.h2, {
      id: "高级迁移注意事项-advanced-migration-considerations",
      children: "高级迁移注意事项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Advanced migration considerations"
    }), "\n", _jsx(_components.p, {
      children: "虽然上面的迁移指南是一个很好的起点，但单一仓库的可能性和功能范围之广意味着很难为所有情况创建通用的说明。下面，我们列出了一些你可能正在考虑的常见后续步骤。"
    }), "\n", _jsx(_components.p, {
      children: "¥While the migration guide above is a good starting point, the breadth of possibilities and capabilities of monorepos means that its difficult to create generalized instructions for all cases. Below, we’ve listed some common next steps that you may be thinking about."
    }), "\n", _jsx(_components.h3, {
      id: "逐步迁移复杂的单一存储库-migrate-complex-monorepos-incrementally",
      children: "逐步迁移复杂的单一存储库 "
    }), "\n", _jsx(_components.p, {
      children: "¥Migrate complex monorepos incrementally"
    }), "\n", _jsx(_components.p, {
      children: "我们鼓励增量迁移，这意味着你的代码库中将同时包含 Nx 和 Turborepo。确保花时间了解 Nx 任务图的构建方式。拆分任务图可能包括以下策略："
    }), "\n", _jsx(_components.p, {
      children: "¥We encourage incremental migration, meaning you will have both of Nx and Turborepo in your repository at the same time. Make sure to spend time understanding how your Nx task graph is constructed. Splitting up the task graph may include strategies like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["一次迁移一个任务：将 ", _jsx(_components.code, {
            children: "nx run lint"
          }), " 更改为 ", _jsx(_components.code, {
            children: "turbo run lint"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Migrating one task at a time"
          }), ": Changing ", _jsx(_components.code, {
            children: "nx run lint"
          }), " to ", _jsx(_components.code, {
            children: "turbo run lint"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["一次迁移一个包/项目：将 ", _jsx(_components.code, {
            children: "nx run-many lint test --projects=web"
          }), " 更改为 ", _jsx(_components.code, {
            children: "turbo run lint test --filter=web"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Migrating one package/project at a time"
          }), ": Changing ", _jsx(_components.code, {
            children: "nx run-many lint test --projects=web"
          }), " to ", _jsx(_components.code, {
            children: "turbo run lint test --filter=web"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["重复运行某些任务：为了确保稳定性，你可以选择在迁移的早期阶段仍在熟悉和建立确定性时运行 ", _jsx(_components.code, {
            children: "turbo run lint"
          }), " 和 ", _jsx(_components.code, {
            children: "nx run lint"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Double-running some of your tasks"
          }), ": To ensure stability, you may choose to run ", _jsx(_components.code, {
            children: "turbo run lint"
          }), " ", _jsx(_components.strong, {
            children: "and"
          }), " ", _jsx(_components.code, {
            children: "nx run lint"
          }), " while you're still getting comfortable and building certainty in the early phases of your migration."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "在使用依赖的位置安装它们-installing-dependencies-where-theyre-used",
      children: "在使用依赖的位置安装它们 "
    }), "\n", _jsx(_components.p, {
      children: "¥Installing dependencies where they're used"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 建议使用 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies#best-practices-for-dependency-installation",
        children: "在使用它们的地方安装包"
      }), " 来提高缓存命中率，增强依赖修剪能力，并向开发者明确哪些依赖对应哪些包。这与 Nx 策略不同，Nx 策略将所有依赖安装在仓库的根目录下，从而使所有依赖都可供工作区中的所有包使用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo recommends ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies#best-practices-for-dependency-installation",
        children: "installing packages where they're used"
      }), " to improve cache hit ratios, help dependency pruning capability, and clarify for developers which dependencies are meant for which packages. This is different from the Nx strategy, where all dependencies are installed at the root of the repository, making all dependencies available to all packages in the workspace."]
    }), "\n", _jsxs(_components.p, {
      children: ["过去，Nx 建议将所有依赖安装在仓库的根目录中，从而使所有依赖都可供工作区中的所有包使用。如果你遵循此指南，我们强烈建议你将需要依赖的包和应用移至 ", _jsx(_components.code, {
        children: "package.json"
      }), "。", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        children: "访问我们关于管理依赖的文档"
      }), " 了解更多。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Historically, Nx has recommended installing all dependencies in the root of the repository, making all dependencies available to all packages in the Workspace. If you followed this guidance, we highly recommend that you move dependencies to the ", _jsx(_components.code, {
        children: "package.json"
      }), "'s for packages and applications that need them. ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        children: "Visit our documentation on managing dependencies"
      }), " to learn more."]
    }), "\n", _jsx(_components.h3, {
      id: "创建共享包-creating-shared-packages",
      children: "创建共享包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Creating shared packages"
    }), "\n", _jsx(_components.p, {
      children: "你将按照与上述大致相同的步骤将包添加到包管理器的工作区。"
    }), "\n", _jsx(_components.p, {
      children: "¥You’ll follow roughly the same set of steps as above to add a package to your package manager’s workspace."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["确保软件包的目录包含在工作区定义中（例如 ", _jsx(_components.code, {
            children: "./packages/*"
          }), " ）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Ensure the package’s directory is included in the workspace definition (like ", _jsx(_components.code, {
            children: "./packages/*"
          }), " )."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "package.json"
          }), " 添加到包含其运行所需脚本的包中。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Add a ", _jsx(_components.code, {
            children: "package.json"
          }), " to the package with the scripts it needs to run."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["检查 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中的任务依赖，以确保你的依赖图符合你的要求。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Check task dependencies in ", _jsx(_components.code, {
            children: "turbo.json"
          }), " to make sure your dependency graph meets your requirements."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "多语言单一仓库-multi-language-monorepos",
      children: "多语言单一仓库 "
    }), "\n", _jsx(_components.p, {
      children: "¥Multi-language monorepos"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 原生支持 JavaScript 和 TypeScript，并支持你想要使用的任何其他语言。", _jsx(_components.a, {
        href: "/docs/guides/multi-language",
        children: "访问多语言支持文档"
      }), " 了解更多。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo natively supports JavaScript and TypeScript, with secondary support for any other languages you’d like to use. ", _jsx(_components.a, {
        href: "/docs/guides/multi-language",
        children: "Visit the Multi-Language support documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h2, {
      id: "配置等效项-configuration-equivalents",
      children: "配置等效项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Configuration equivalents"
    }), "\n", _jsxs(_components.p, {
      children: ["可以使用下表将 ", _jsx(_components.code, {
        children: "nx.json"
      }), " 中的配置映射到 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Configuration found in ", _jsx(_components.code, {
        children: "nx.json"
      }), " can be mapped to ", _jsx(_components.code, {
        children: "turbo.json"
      }), " using the tables below."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["Nx 和 Turborepo 中用于捕获文件的 glob 大部分是相同的。有关详细信息和特殊情况，请参阅 ", _jsx(_components.a, {
          href: "/docs/reference/globs",
          children: "我们的文件全局规范"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥The majorify of globs for capturing files are the same between Nx and\nTurborepo. See ", _jsx(_components.a, {
          href: "/docs/reference/globs",
          children: "our file glob specification"
        }), " for\ndetails and edge cases."]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "全局配置-global-configuration",
      children: "全局配置 "
    }), "\n", _jsx(_components.p, {
      children: "¥Global configuration"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Nx"
          }), _jsx(_components.th, {
            children: "Turborepo"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "sharedGlobals"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#globaldependencies",
              children: _jsx(_components.code, {
                children: "globalDependencies"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "sharedGlobals.env"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#globalenv",
              children: _jsx(_components.code, {
                children: "globalEnv"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "sharedGlobals.namedInput"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#globaldependencies",
              children: _jsx(_components.code, {
                children: "globalDependencies"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "cacheDirectory"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#cachedir",
              children: _jsx(_components.code, {
                children: "cacheDir"
              })
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "任务配置-task-configuration",
      children: "任务配置 "
    }), "\n", _jsx(_components.p, {
      children: "¥Task configuration"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Nx"
          }), _jsx(_components.th, {
            children: "Turborepo"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "inputs"
            }), " 文件"]
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#inputs",
              children: _jsx(_components.code, {
                children: "tasks[task].inputs"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inputs.env"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#env",
              children: _jsx(_components.code, {
                children: "tasks[task].env"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "outputs"
            }), " 文件"]
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#outputs",
              children: _jsx(_components.code, {
                children: "tasks[task].outputs"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "cache"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/configuration#cache",
              children: _jsx(_components.code, {
                children: "tasks[task].cache"
              })
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "cli-等效项-cli-equivalents",
      children: "CLI 等效项 "
    }), "\n", _jsx(_components.p, {
      children: "¥CLI equivalents"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Nx"
          }), _jsx(_components.th, {
            children: "Turborepo"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "nx generate"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/generate",
              children: _jsx(_components.code, {
                children: "turbo generate"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "nx run"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run",
              children: _jsx(_components.code, {
                children: "turbo run"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "nx run-many"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run",
              children: _jsx(_components.code, {
                children: "turbo run"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "nx reset"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--force",
              children: _jsx(_components.code, {
                children: "--force"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--parallel"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--concurrency-number--percentage",
              children: _jsx(_components.code, {
                children: "--concurrency"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--nxBail"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--continueoption",
              children: _jsx(_components.code, {
                children: "--continue"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--projects"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--filter-string",
              children: _jsx(_components.code, {
                children: "--filter"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--graph"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--graph-file-name",
              children: _jsx(_components.code, {
                children: "--graph"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--output-style"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--log-order-option",
              children: _jsx(_components.code, {
                children: "--log-order"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--no-cloud"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--cache-options",
              children: _jsx(_components.code, {
                children: "--cache"
              })
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbose"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/docs/reference/run#--verbosity",
              children: _jsx(_components.code, {
                children: "--verbosity"
              })
            })
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
